(function () {
	const body = document.querySelector('html[data-scheme]')
	if (!body || !window.cscoDarkMode) return

	const attachToggleHandlers = () => {
		const toggleBtns = document.querySelectorAll('.header__toggle-scheme')
		toggleBtns.forEach((btn) => {
			if (btn.dataset.schemeToggleBound) return
			btn.dataset.schemeToggleBound = '1'
			btn.addEventListener('click', (e) => {
				e.preventDefault()

				if ('auto' === body.getAttribute('data-scheme')) {
					if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
						window.cscoDarkMode.changeScheme('light', true)
					} else if (window.matchMedia('(prefers-color-scheme: light)').matches) {
						window.cscoDarkMode.changeScheme('dark', true)
					}
				} else {
					if ('dark' === body.getAttribute('data-scheme')) {
						window.cscoDarkMode.changeScheme('light', true)
					} else {
						window.cscoDarkMode.changeScheme('dark', true)
					}
				}
			})
		})
	}

	attachToggleHandlers()
	document.addEventListener('shopify:section:load', () => {
		setTimeout(attachToggleHandlers, 100)
	})
})()
